import DatePicker from "react-datepicker";

const CustomPeriod = (props) => {
  const { customPeriods, setCustomPeriods, setErrorCustom, errorCustom } =
    props;

  const handleCustomPeriodChange = (index, field, value) => {
    const newCustomPeriods = [...customPeriods];
    newCustomPeriods[index][field] = value;
    setCustomPeriods(newCustomPeriods);

    // Check if any field is filled
    const isAnyFieldFilled = Object.keys(newCustomPeriods[index]).some(
      (key) => newCustomPeriods[index][key]
    );

    // Update error state accordingly
    const newErrors = [...errorCustom];
    newErrors[index] = {
      startDate: isAnyFieldFilled && !newCustomPeriods[index].startDate,
      endDate: isAnyFieldFilled && !newCustomPeriods[index].endDate,
      custom_price: isAnyFieldFilled && !newCustomPeriods[index].custom_price,
      custom_weekly_price:
        isAnyFieldFilled && !newCustomPeriods[index].custom_weekly_price,
      custom_price_additional:
        isAnyFieldFilled && !newCustomPeriods[index].custom_price_additional,
    };
    setErrorCustom(newErrors);
  };

  const handleAddCustomPeriod = () => {
    setCustomPeriods([
      ...customPeriods,
      {
        startDate: null,
        endDate: null,
        custom_price: "",
        custom_weekly_price: "",
        custom_price_additional: "",
      },
    ]);
    setErrorCustom([
      ...errorCustom,
      {
        startDate: true,
        endDate: true,
        custom_price: true,
        custom_weekly_price: true,
        custom_price_additional: true,
      },
    ]);
  };

  const handleMinusClickOne = (index) => {
    if (customPeriods.length > 1) {
      const newExtraServicePrices = [...customPeriods];
      newExtraServicePrices.splice(index, 1);
      setCustomPeriods(newExtraServicePrices);
    }
  };

  return (
    <>
      {customPeriods?.map((period, index) => (
        <>
          <div className="md:col-span-6 text-left">
            <label>Start Date</label>
            <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center">
              <i className="fal fa-calendar-day" />
              <DatePicker
                selected={period.startDate}
                onChange={(date) => {
                  handleCustomPeriodChange(index, "startDate", date);
                  handleCustomPeriodChange(index, "endDate", null);
                }}
                className="react-datepicker-wrapper"
                placeholderText="Start Date"
              />
            </div>
            {errorCustom[index]?.startDate && (
              <p style={{ color: "red" }}>Required</p>
            )}
          </div>

          <div className="md:col-span-6 text-left">
            <label>End Date</label>
            <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center">
              <i className="fal fa-calendar-day" />
              <DatePicker
                selected={period.endDate}
                onChange={(date) =>
                  handleCustomPeriodChange(index, "endDate", date)
                }
                placeholderText="End Date"
                minDate={period.startDate}
                className="react-datepicker-wrapper"
              />
            </div>
            {errorCustom[index]?.endDate && (
              <p style={{ color: "red" }}>Required</p>
            )}
          </div>

          <div className="md:col-span-4 text-left">
            <label>Nightly Price</label>
            <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center">
              <i className="fal fa-dollar-sign" />
              <input
                type="number"
                placeholder="Nightly Price"
                name="custom_price"
                value={period.custom_price}
                onChange={(e) =>
                  handleCustomPeriodChange(
                    index,
                    "custom_price",
                    e.target.value
                  )
                }
              />
            </div>
            {errorCustom[index]?.custom_price && (
              <p style={{ color: "red" }}>Required</p>
            )}
          </div>

          <div className="md:col-span-4 text-left">
            <label>Weekend Price</label>
            <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center">
              <i className="fal fa-dollar-sign" />
              <input
                type="number"
                placeholder="Weekend Price"
                value={period.custom_weekly_price}
                name="custom_weekly_price"
                onChange={(e) =>
                  handleCustomPeriodChange(
                    index,
                    "custom_weekly_price",
                    e.target.value
                  )
                }
              />
            </div>
            {errorCustom[index]?.custom_weekly_price && (
              <p style={{ color: "red" }}>Required</p>
            )}
          </div>

          <div className="md:col-span-4 text-left">
            <label>Price Per Additional Guest</label>
            <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center">
              <i className="fal fa-dollar-sign" />
              <input
                type="number"
                placeholder="Price Per Additional Guest"
                value={period.custom_price_additional}
                name="custom_price_additional"
                onChange={(e) =>
                  handleCustomPeriodChange(
                    index,
                    "custom_price_additional",
                    e.target.value
                  )
                }
              />
            </div>
            {errorCustom[index]?.custom_price_additional && (
              <p style={{ color: "red" }}>Required</p>
            )}
          </div>

          <div className="md:col-span-12 flex justify-start items-start">
            {customPeriods?.length > 1 && (
              <button
                className="border border-[#3b4249] font-medium bg-[#8ec639] rounded-md text-white px-8 py-3"
                onClick={() => handleMinusClickOne(index)}
              >
                Remove Custom
              </button>
            )}
          </div>
        </>
      ))}

      <div className="md:col-span-12 text-left flex justify-end items-end">
        <button
          onClick={handleAddCustomPeriod}
          className="border border-[#3b4249] font-medium bg-[#8ec639] rounded-md text-white px-8 py-3"
        >
          Add Custom Period
        </button>
      </div>
    </>
  );
};

export default CustomPeriod;
